import { concatUrl } from '@hozana/router/concatUrl'
import { EVENT_ORIGIN } from '@hozana/tracking/constants'

import { API_PATHNAME as rawAPI_PATHNAME } from './api'
import { REWRITTEN_PAGES, STATIC_PAGES_REVALIDATE, PAGE as rawPAGE } from './pages'

export { REWRITTEN_PAGES, STATIC_PAGES_REVALIDATE }

export const API_PATHNAME = rawAPI_PATHNAME
export type API_PATHNAME = TObjectValues<typeof rawAPI_PATHNAME>

export const PAGE = rawPAGE
export type PAGE = TObjectValues<typeof rawPAGE>

export const IMMUTABLE_PREFIX = `/immutable/${CONF_KEYS.BUILD_ID}`

export const newCommunityRouteStart = '/community'

export const newRoutes = {
  prayerSpace: () => '/prayer-space',
  communities: () => '/communities',
  community: (idSlug: string, origin: EVENT_ORIGIN) => concatUrl(`${newCommunityRouteStart}/${idSlug}`, { origin }),
  intentions: () => '/intentions',
  intention: (intentionId: number, shareToken: string) => `/intention/${intentionId}-${shareToken}`,
  conversations: () => '/messages',
  newConversation: (userId: number) => concatUrl('/messages', { userId: userId.toString() }),
  settings: () => '/settings',
  settingsCommunities: () => '/settings/notifications/communities',
  publication: (idSlug: string) => `/publications/${idSlug}`,
}
